/**
 * PlusRoundedEndsIcon component - renders a plus with rounded edges icon as SVG
 * @returns React component that renders the plus with rounded edges icon
 */
const PlusRoundedEndsIcon = () => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.0172 12.3305C7.51241 12.7655 5.84112 12.6386 4.35653 11.8596C3.9838 11.664 3.84011 11.2032 4.0356 10.8306C4.23118 10.4578 4.69199 10.3141 5.06453 10.5094C6.19101 11.1 7.45024 11.1954 8.59477 10.8658C9.7388 10.535 10.756 9.78352 11.3989 8.67088C12.0575 7.52934 12.1901 6.23638 11.8749 5.05603C11.5578 3.87608 10.7962 2.82269 9.65527 2.16353C8.5139 1.50502 7.22053 1.37201 6.04043 1.68749C4.86066 2.00474 3.80719 2.766 3.1479 3.90717C3.10152 3.98751 3.05795 4.06861 3.01685 4.15025L4.02728 4.21611C4.13696 4.22334 4.23652 4.27996 4.29023 4.36528C4.34396 4.45129 4.3452 4.555 4.29318 4.64057L2.22026 8.05188C2.16057 8.1492 2.04254 8.20629 1.91728 8.19877C1.79185 8.19005 1.68176 8.11843 1.63617 8.01378L0.0234055 4.36245C-0.0173685 4.27061 -0.00269324 4.16805 0.0619091 4.09015C0.126039 4.01156 0.231976 3.96865 0.342096 3.97592L1.40083 4.045C1.51817 3.73859 1.65885 3.43734 1.82767 3.14493C2.69432 1.6431 4.0938 0.630163 5.64598 0.215116C7.1977 -0.201367 8.91579 -0.0240565 10.4175 0.843326C11.9191 1.70989 12.932 3.10935 13.3472 4.66139C13.7638 6.21316 13.5864 7.93159 12.7191 9.43306C11.8742 10.8971 10.5228 11.897 9.0172 12.3305Z"
        fill="#616161"
      />
    </svg>
  );
};

export default PlusRoundedEndsIcon;
